import { render } from "./HardwareConfigure.vue?vue&type=template&id=a44f5b2a&scoped=true"
import script from "./HardwareConfigure.vue?vue&type=script&lang=js"
export * from "./HardwareConfigure.vue?vue&type=script&lang=js"

import "./HardwareConfigure.vue?vue&type=style&index=0&id=a44f5b2a&scoped=true&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a44f5b2a"]])

export default __exports__